<!-- ProductCard.vue -->
<template>
  <div class="product-card">
    <div class="product-image-wrapper">
      <img
        :src="imgDomain + item.image_url"
        :alt="item.title"
        class="product-image"
      />
    </div>
    <div class="product-bottom">
      <div class="product-content">
        <h3 class="product-title desc desc-20">
          <b>{{ item.title }}</b>
        </h3>
        <p class="product-host" v-if="item.host">
          {{ item.host }} ({{ item.port }})
        </p>
        <p class="desc product-dimensions">{{ item.dimensions }}</p>
      </div>
      <div class="product-content">
        <p class="product-price title big weight-900">
          <span>{{ item.price }}</span>
          <img src="@/assets/coin.svg" alt="coin" class="coin" />
        </p>

        <button @click="handleClick" class="button secondary blue">
          <span>{{ $t("BUY NOW") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { MODALS } from "../store/modules/modals";

export default {
  name: "ProductCard",
  props: ["item", "currency", "isAuth"],
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    handleClick() {
      if (this.isAuth) {
        this.$router.push({ path: "/profile/buy-island" });
      } else {
        this.$store.dispatch("modals/openModal", {
          modalName: MODALS.SIGNUP,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  width: 466px;
  background: #fcfdf7;
  border: 2px solid #ffffff;
  border-radius: 30px;
  position: relative;
}

.product-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 24px 45px;
}

.product-title {
  margin-bottom: 8px;
  color: #112a3a;
}

.product-dimensions {
  color: #112a3a80;
  font-size: 12px;
}

.product-image-wrapper {
  width: 100%;
  height: 180px;
}

.product-content .button.secondary {
  max-width: 200px;
}
.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
}

.product-price {
  color: #ac272b;
  font-family: "Inter", sans-serif;
  display: flex;
  align-items: center;
  gap: 12px;
  .coin {
    width: 50px;
  }
}

.button.secondary {
  bottom: 0;
  position: absolute;
  left: 50%;
  max-width: 289px;
  transform: translateX(-50%) translateY(50%);
}

@media (max-width: 768px) {
  .product-card {
    width: 100%;
  }
}
</style>
